import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationShoppingStore = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationShoppingStore',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70607)",
    d: "M95.55 83.58h-94v7h94v-7Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70607)",
    d: "M89.15 35.98h-80v47.6h80v-47.6Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#B37AEA",
    fillRule: "evenodd",
    d: "M89.15 45.884V35.98h-80v4.476a14.476 14.476 0 0 0 11.59 5.784c4.43 0 8.39-1.99 11.05-5.13 2.66 3.13 6.62 5.13 11.05 5.13 4.4 0 8.34-1.97 11-5.07 2.66 3.1 6.6 5.07 11 5.07 4.16 0 7.91-1.77 10.55-4.58 2.64 2.81 6.39 4.58 10.55 4.58 1.103 0 2.178-.123 3.21-.356Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_21134_70607)",
    fillRule: "evenodd",
    d: "M74.64 27.87H1.55c0 8.01 6.49 14.5 14.5 14.5 4.43 0 8.39-1.99 11.05-5.13 2.66 3.13 6.62 5.13 11.05 5.13 4.4 0 8.34-1.97 11-5.07 2.66 3.1 6.6 5.07 11 5.07 4.16 0 7.91-1.77 10.55-4.58 2.64 2.81 6.39 4.58 10.55 4.58 8.01 0 14.5-6.49 14.5-14.5H74.64Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_21134_70607)",
    fillRule: "evenodd",
    d: "M11.15 9.58 1.535 27.883l94.215.097-7.5-18.4h-77.1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9E58FF",
    d: "M74.95 50.74h-51.3v32.84h51.3V50.74Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint4_linear_21134_70607)",
    d: "M67.63 57.45H30.98v26.13h36.65V57.45Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70607",
    x1: 45.338,
    x2: 49.369,
    y1: 68.878,
    y2: 91.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70607",
    x1: 18.712,
    x2: 99.324,
    y1: 42.206,
    y2: 88.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD1FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9E58FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_21134_70607",
    x1: 26.601,
    x2: 73.123,
    y1: 3.336,
    y2: 60.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.061,
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_21134_70607",
    x1: 38.379,
    x2: 54.189,
    y1: -0.334,
    y2: 43.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#F45FF6"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint4_linear_21134_70607",
    x1: 60.827,
    x2: 38.021,
    y1: 89.725,
    y2: 51.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#8E9BFF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.997,
    stopColor: "#4961FF"
  }))));
};
ColoredIllustrationShoppingStore.displayName = 'ColoredIllustrationShoppingStore';
export default withProvisionalOverrideFromContext(ColoredIllustrationShoppingStore);
//# sourceMappingURL=index.js.map